import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={25}
    height={16}
    viewBox="0 0 25 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24.2091 8.46101C24.5996 8.07049 24.5996 7.43732 24.2091 7.0468L17.8451 0.682837C17.4546 0.292313 16.8214 0.292313 16.4309 0.682837C16.0404 1.07336 16.0404 1.70653 16.4309 2.09705L22.0877 7.7539L16.4309 13.4108C16.0404 13.8013 16.0404 14.4344 16.4309 14.825C16.8214 15.2155 17.4546 15.2155 17.8451 14.825L24.2091 8.46101ZM0.501953 8.75391L23.502 8.7539L23.502 6.7539L0.501953 6.75391L0.501953 8.75391Z"
      fill="#636F7C"
    />
  </svg>
);
export default SVGComponent;
